import createPersistedState from 'vuex-persistedstate'

export const dataState = createPersistedState({
  paths: ['materials.newMaterial', 'materials.materialFormIsModified']
})
